import { http } from 'http';

export default {
  createTemplate: data =>
    http.post(`/cms/${data.locale}/templates`, data.body, {
      headers: {
        appId: data.appId,
        partnerId: data.partnerId || 0
      }
    }),
  createPattern: data =>
    http.post(`/cms/${data.locale}/templates/${data.templateName}/patterns`, data.body, {
      headers: {
        appId: data.appId,
        partnerId: data.partnerId || 0
      }
    }),
  createElement: data =>
    http.post(
      `/cms/${data.locale}/templates/${data.templateName}/patterns/${data.patternName}/elements`,
      data.body,
      {
        headers: {
          appId: data.appId,
          partnerId: data.partnerId || 0
        }
      }
    )
};
